<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1> Odjava</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
    <p v-if="!status.logedIn">Uspešno ste se odjavili iz aplikacije. Svetujemo vam, po uporabi zaprete tudi spletni brskalnik!</p>
    
    <p v-else>Pri odjavi je prišlo do napake. Še enkrat se poskusite odjaviti!</p>
    </div>
    </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
    computed: {
        ...mapState('account', ['status'])
    },
    created () {
        // reset login status
        this.logout();
    },
    methods: {
        ...mapActions('account', ['login', 'logout']),
    }
    
};
</script>

<style>
form {
display:flex;
flex-direction:column;
}


</style>